import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { RepeatByDateKind } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import dayjs, { Dayjs } from 'dayjs'
import { CarrierVisitScheduleTimings } from './CarrierVisitScheduleTimings'

export interface ICarrierVisitSchedule {
  showTimingOptions: number
  selectedRadioOption: string
  repeatEvery: number
  repeatBy: RepeatByDateKind
  endsOn?: Dayjs
  endsAfter?: number
}

export const carrierVisitScheduleDefaultValues: ICarrierVisitSchedule = {
  showTimingOptions: 0,
  selectedRadioOption: 'on',
  repeatEvery: 1,
  repeatBy: RepeatByDateKind.Week,
  endsOn: dayjs().add(1, 'week'),
  endsAfter: 2,
}

interface IProps {
  schedule: ICarrierVisitSchedule
  handleSchedule: (newValue: ICarrierVisitSchedule) => void
}
export const CarrierVisitSchedule = ({ schedule, handleSchedule }: IProps) => {
  const { t } = useTranslate()

  return (
    <>
      <Grid container direction='row' columnSpacing={{ xs: 1 }}>
        <Grid mt={'1rem'} size={6}>
          <FormControl fullWidth>
            <InputLabel color='secondary'>{t('repeatingVisit', 'Repeating Visit')}</InputLabel>
            <Select
              fullWidth
              defaultValue={carrierVisitScheduleDefaultValues.showTimingOptions}
              label={t('repeatingVisit', 'Repeating Visit')}
              onChange={e =>
                handleSchedule({
                  ...schedule,
                  showTimingOptions: e.target.value as number,
                })
              }
            >
              <MenuItem value={0}>{t('singleVisit', 'Single Visit')}</MenuItem>
              <MenuItem value={1}>{t('repeatingVisit', 'Repeating Visit')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <CarrierVisitScheduleTimings schedule={schedule} onChange={handleSchedule} />
    </>
  )
}
